const ru = {
  app: {
    name: "Datascratch",
    untitled: "Без названия",
    loading: "Загрузка…",
    slowTitle: "Не удаётся открыть Datascratch",
    slowText: "Открытие сохранённого сеанса затянулось. Попробуйте ещё раз или войдите заново — заметки в сохранности.",
    retry: "Повторить",
    signInAgain: "Войти заново",
    restoreFailed: "Не удалось открыть сохранённый сеанс в этом браузере. Войдите снова — заметки в сохранности.",
    defaultSpace: "Личное",
    defaultNotebook: "Заметки",
    welcomeTitle: "Добро пожаловать",
    welcomeBody1: "Это ваш первый документ. Пишите, ставьте задачи с [ ] и рисуйте прямо поверх текста.",
    welcomeBody2: "Нажмите ⌘K, чтобы найти что угодно или выполнить команду.",
  },
  common: {
    expand: "Развернуть",
    collapse: "Свернуть",
    cancel: "Отмена",
    save: "Сохранить",
    create: "Создать",
    delete: "Удалить",
    rename: "Переименовать",
    close: "Закрыть",
    done: "Готово",
    copy: "Копировать",
    copied: "Скопировано",
    continue: "Продолжить",
    back: "Назад",
    open: "Открыть",
    retry: "Повторить",
    search: "Поиск",
    more: "Ещё",
    never: "Никогда",
    today: "Сегодня",
    tomorrow: "Завтра",
    yesterday: "Вчера",
    nextWeek: "След. неделя",
    pickDate: "Дата…",
    none: "Нет",
    clear: "Убрать",
    requiresOnline: "Нужно подключение к серверу",
  },
  auth: {
    revokedTitle: "Сеанс на этом устройстве завершён",
    revokedText: "Сервер больше не принимает этот вход. Войдите снова.",
    wipedTitle: "Это устройство отключено от аккаунта с другого устройства",
    wipedText: "Данные на нём удалены. Войдите снова — заметки загрузятся с сервера.",
    revokedUnsent_one: "{{count}} неотправленное изменение сохранено здесь и отправится после входа.",
    revokedUnsent_few: "{{count}} неотправленных изменения сохранены здесь и отправятся после входа.",
    revokedUnsent_many: "{{count}} неотправленных изменений сохранены здесь и отправятся после входа.",
    revokedUnsent_other: "{{count}} неотправленного изменения сохранены здесь и отправятся после входа.",
    revokedForget: "Удалить данные с этого устройства",
    keptTitle: "Неотправленные изменения сохранены",
    keptText: "Войдите в этот же аккаунт — они отправятся.",
    revokedForgetConfirm: "Удалить с этого устройства все данные аккаунта{{unsent}}? На сервере и других устройствах ничего не изменится.",
    revokedForgetUnsent: ", включая неотправленные изменения",
    tagline: "Заметки, в которых рукопись живёт в тексте.",
    signIn: "Войти",
    signUp: "Создать аккаунт",
    email: "Эл. почта",
    password: "Пароль",
    passwordRepeat: "Повторите пароль",
    passwordHint: "Не меньше 10 символов. Пароль шифрует заметки — сервер его не знает.",
    passwordTooShort: "Пароль короче 10 символов",
    passwordMismatch: "Пароли не совпадают",
    noAccount: "Нет аккаунта?",
    haveAccount: "Уже есть аккаунт?",
    forgot: "Забыли пароль?",
    wrongCredentials: "Неверная почта или пароль",
    emailTaken: "Эта почта уже зарегистрирована",
    serverUnavailable: "Сервер недоступен. Проверьте подключение.",
    unsafeKdf: "Сервер прислал небезопасные параметры шифрования пароля. Вход отменён — проверьте адрес сервера.",
    deriving: "Защищаем ключи…",
    recoveryTitle: "Ваш ключ восстановления",
    recoveryText:
      "Заметки зашифрованы паролем, который знаете только вы. Если забудете пароль, вернуть доступ можно только этим ключом. Сохраните его в надёжном месте — мы показываем его один раз.",
    recoveryCopy: "Скопировать ключ",
    recoveryDownload: "Скачать файлом",
    recoveryConfirmLabel: "Введите последние 4 символа ключа, чтобы подтвердить",
    recoveryConfirmWrong: "Символы не совпадают",
    recoverySaved: "Я сохранил ключ",
    recoverySkip: "Пропустить",
    recoverySkipTitle: "Пропустить проверку ключа?",
    recoverySkipWarning: "Без ключа восстановления забытый пароль нельзя сбросить — заметки останутся зашифрованными навсегда. Ключ можно снова посмотреть в настройках.",
    recoveryBack: "Вернуться к ключу",
    recoverTitle: "Восстановление доступа",
    recoverText: "Введите почту и ключ восстановления, затем задайте новый пароль. Заметки останутся на месте.",
    recoverOthersWiped: "Все устройства, где вы вошли, будут отключены, данные на них удалены. Заметки останутся на сервере.",
    recoveryKey: "Ключ восстановления",
    recoveryKeyInvalid: "Ключ выглядит неверно: 52 символа после DS1-",
    newPassword: "Новый пароль",
    recover: "Восстановить",
    wrongRecovery: "Почта или ключ восстановления не подходят",
  },
  nav: {
    tabs: "Вкладки",
    allDocs: "Все документы",
    tasks: "Задачи",
    calendar: "Календарь",
    starred: "Избранное",
    folders: "Блокноты",
    tags: "Теги",
    moreCount: "Ещё {{count}}",
    allTags: "Все теги",
    searchTags: "Найти тег",
    trash: "Корзина",
    settings: "Настройки",
    search: "Поиск",
    newDoc: "Новый документ",
    newDocIn: "Новый документ — в «{{name}}». Выбрать другой блокнот",
    newDocInShort: "в «{{name}}»",
    newFolder: "Новая папка",
    newNotebook: "Новый блокнот",
    newSpace: "Новое пространство",
    spaces: "Пространства",
    addToNotebook: "Добавить в блокнот",
    fullScreen: "На весь экран",
    exitFullScreen: "Выйти из полноэкранного режима",
    collapseSidebar: "Скрыть панель",
    expandSidebar: "Показать панель",
    today: "Сегодня",
    shared: "Доступные мне",
  },
  sync: {
    online: "Синхронизировано",
    syncing: "Синхронизация…",
    connecting: "Подключение…",
    offline: "Офлайн — изменения сохранены на устройстве",
    pending_one: "{{count}} изменение ждёт отправки",
    pending_few: "{{count}} изменения ждут отправки",
    pending_many: "{{count}} изменений ждут отправки",
    pending_other: "{{count}} изменения ждут отправки",
    notSent: "Не отправлено: {{count}}",
    uploadingImage: "Отправляется картинка…",
    uploadingImages: "Отправляются картинки: {{done}} из {{total}}",
    uploadingFile: "Отправляется вложение…",
    uploadingFiles: "Отправляются вложения: {{done}} из {{total}}",
    storageFull: "Хранилище браузера заполнено — изменения не сохраняются на устройстве.",
    storageFullHint: "Они дойдут до сервера, пока открыта вкладка; освободите место в браузере, чтобы они сохранялись и без сети.",
    unreadableTitle: "Часть изменений здесь пока не читается",
    unreadableText: "Они сохранены другим ключом. Остальное в блокноте синхронизировано.",
    unreadableShow: "Нечитаемые изменения",
    unreadable_one: "в {{count}} документе есть старые изменения, которые не читаются",
    unreadable_few: "в {{count}} документах есть старые изменения, которые не читаются",
    unreadable_many: "в {{count}} документах есть старые изменения, которые не читаются",
    unreadable_other: "в {{count}} документа есть старые изменения, которые не читаются",
    notSentHint: "Сервер не принял изменения. Они сохранены на этом устройстве.",
    retry: "Повторить",
  },
  tabs: {
    pin: "Закрепить вкладку",
    unpin: "Открепить вкладку",
    pinned: "закреплена",
    tidy: "Убирать вкладки, которые не открывали",
    tidyHint: "Они попадут в «Недавно закрытые» в обзоре вкладок. Закреплённые и открытая не убираются.",
    tidy1: "1 день",
    tidy7: "7 дней",
    tidy30: "30 дней",
    tidyNever: "Никогда",
    overview: "Все вкладки",
    more_one: "Ещё {{count}} вкладка",
    more_few: "Ещё {{count}} вкладки",
    more_many: "Ещё {{count}} вкладок",
    more_other: "Ещё {{count}} вкладки",
    search: "Найти вкладку",
    groupNone: "Все",
    groupNotebook: "По блокнотам",
    closeOthers: "Закрыть остальные",
    recentlyClosed: "Недавно закрытые",
    none: "Открытых вкладок нет",
    count_one: "{{count}} вкладка",
    count_few: "{{count}} вкладки",
    count_many: "{{count}} вкладок",
    count_other: "{{count}} вкладки",
  },
  docs: {
    insertPicture: "Вставить картинку",
    insertPictureFailed: "Не удалось вставить картинку: {{reason}}",
    filterPlaceholder: "Искать в этом списке",
    filterClear: "Очистить поиск",
    noMatches: "Ничего не найдено",
    noMatchesHint: "Попробуйте другие слова или поиск по всему пространству — ⌘K.",
    emptyTitle: "Здесь пока пусто",
    emptyText: "Создайте первый документ — пишите, рисуйте, ставьте задачи.",
    emptyFolder: "В папке нет документов",
    emptyShort: "Пусто",
    emptyStarred: "Отмечайте важное звёздочкой — оно появится здесь.",
    emptyTag: "Нет документов с этим тегом",
    emptyTrash: "Корзина пуста",
    trashHint: "Документы удаляются навсегда через 30 дней.",
    grid: "Сетка",
    list: "Список",
    sortUpdated: "По изменению",
    sortCreated: "По созданию",
    sortTitle: "По названию",
    updated: "Изменён {{when}}",
    count_one: "{{count}} документ",
    count_few: "{{count}} документа",
    count_many: "{{count}} документов",
    count_other: "{{count}} документа",
    subfolders: "Папки",
    folders_one: "{{count}} папка",
    folders_few: "{{count}} папки",
    folders_many: "{{count}} папок",
    folders_other: "{{count}} папки",
    star: "В избранное",
    unstar: "Убрать из избранного",
    duplicate: "Дублировать",
    moveTo: "Переместить в…",
    closeTab: "Закрыть вкладку",
    moveToNotebook: "Переместить в блокнот…",
    moveToSpace: "Переместить в пространство…",
    movedTo: "Перемещено в «{{name}}»",
    moveFailed: "Не удалось переместить документ. Попробуйте ещё раз.",
    moveNeedsNetwork: "Для переноса в другой блокнот нужно подключение к сети.",
    moveToAgentTitle: "Переместить в «{{name}}»?",
    moveToAgentWarning: "Этот блокнот открыт для ИИ-агентов: сервер сможет читать документ, чтобы агенты могли с ним работать.",
    moveConfirm: "Переместить",
    moveToRoot: "Корень блокнота",
    toTrash: "В корзину",
    restore: "Восстановить",
    deleteForever: "Удалить навсегда",
    deleteForeverConfirm: "Документ будет удалён на всех устройствах без возможности восстановления.",
    openInTab: "Открыть во вкладке",
    share: "Поделиться…",
    history: "История версий",
    style: "Стиль",
    cover: "Обложка",
    backlinks: "Ссылаются сюда",
    noBacklinks: "Пока никто не ссылается",
    trashed: "Документ в корзине",
    readOnlyNewer: "Документ создан более новой версией приложения — только чтение. Обновите приложение.",
    notFound: "Документ не найден",
    notFoundText: "Возможно, он удалён или ещё не синхронизировался.",
    placeholder: "Пишите, или нажмите / для блоков…",
    titlePlaceholder: "Без названия",
    moved: "Перемещено",
    trashedToast: "Документ в корзине",
    undo: "Отменить",
    inbox: "Входящие",
    daily: "Ежедневная заметка",
    newInFolder: "Документ в папке",
    created: "Создан {{when}}",
  },
  folder: {
    newName: "Новая папка",
    color: "Цвет",
    icon: "Значок",
    addSub: "Вложенная папка",
    deleteConfirm: "Папка будет удалена, её документы и вложенные папки переместятся уровнем выше.",
  },
  notebook: {
    modeNotChangedOffline: "Сервер не ответил — режим не изменён. Попробуйте ещё раз.",
    modeNotChanged: "Сервер не принял изменение режима: {{reason}}",
    name: "Название",
    newName: "Новый блокнот",
    mode: "Режим",
    private: "Приватный",
    agent: "Для агентов",
    privateHint: "Сквозное шифрование. Ключ — только на ваших устройствах. Агентам недоступен.",
    agentHint: "Ключ блокнота хранится на сервере, чтобы ИИ-агенты с токеном могли читать и править заметки.",
    agentWarning:
      "Честно: в этом режиме сервер технически может прочитать заметки этого блокнота. Расшифровка происходит только по запросу агента с действительным токеном, но приватность ниже, чем в обычном блокноте.",
    switchToAgent: "Открыть агентам",
    switchToPrivate: "Сделать приватным",
    switchToPrivateText: "Сервер удалит свою копию ключа. Агенты потеряют доступ к блокноту.",
    deleteConfirm: "Блокнот и все его документы будут удалены на всех устройствах.",
    dailyHere: "Ежедневные заметки и Входящие",
  },
  space: { newName: "Новое пространство", deleteNotEmpty: "Сначала удалите или перенесите блокноты пространства." },
  spaces: {
    newShared: "Новое общее пространство",
    newSharedName: "Общее пространство",
    invite: "Пригласить в пространство…",
    members: "Участники…",
    shared: "Общие",
    sharedHint: "Общее пространство: его видят все участники",
    makeSharedTitle: "Сделать «{{name}}» общим?",
    makeSharedText:
      "Участники увидят все блокноты этого пространства — вместе со всей их историей. Вкладки, избранное и поиск у каждого останутся своими.",
    makeShared: "Сделать общим",
    membersTitle: "Участники «{{name}}»",
    membersHint: "Всё в общем пространстве — блокноты, папки и заметки — видят все участники. Редакторы создают и меняют, читатели только читают.",
    role: { owner: "Владелец", editor: "Может редактировать", viewer: "Только чтение" },
    leave: "Выйти из пространства",
    leaveTitle: "Выйти из «{{name}}»?",
    leaveText: "Его блокноты исчезнут с этого устройства. Вернуться можно только по новому приглашению владельца.",
    left: "Вы вышли из общего пространства",
    gone: "Доступ к общему пространству закрыт",
    waiting: "Ждёт ключ от владельца — откроется, когда владелец будет в сети",
    moveToShared: "Перенести в общее пространство",
    moveInTitle: "Перенести «{{notebook}}» в «{{space}}»?",
    moveInText: "Участники пространства увидят весь блокнот — и всю его историю, а не только новое. Отменить это нельзя: уже увиденное останется у них.",
    moveIn: "Перенести",
    movedIn: "Блокнот теперь в «{{space}}»",
    moveToPersonal: "Вынести в личное пространство",
    moveOutTitle: "Вынести «{{notebook}}» в «{{space}}»?",
    moveOutText: "Ключ блокнота сменится: участники перестанут видеть новое. То, что они уже видели, у них останется.",
    moveOut: "Вынести",
    movedOut: "Блокнот теперь в «{{space}}»",
    deleteTitle: "Удалить общее пространство «{{name}}»?",
    deleteText: "Пространство, все его блокноты и заметки удалятся у всех участников. Это нельзя отменить.",
    readOnly: "Только чтение — в этом пространстве вы читатель",
    failed: "Не получилось — попробуйте ещё раз",
    conflict: "Сервер отказал: у блокнота есть свои участники или данные устарели. Обновите страницу и попробуйте ещё раз.",
  },
  palette: {
    placeholder: "Найти документ или команду…",
    docs: "Документы",
    commands: "Команды",
    noResults: "Ничего не найдено",
    newDoc: "Создать документ",
    newDocTitled: "Создать «{{title}}»",
    goTasks: "Открыть задачи",
    goCalendar: "Открыть календарь",
    goToday: "Ежедневная заметка на сегодня",
    goSettings: "Настройки",
    toggleTheme: "Переключить тему",
    toggleSidebar: "Показать/скрыть панель",
    newTask: "Новая задача во Входящие",
    switchSpace: "Пространство: {{name}}",
  },
  tasks: {
    title: "Задачи",
    inbox: "Входящие",
    today: "Сегодня",
    upcoming: "Скоро",
    all: "Все",
    logbook: "Выполненные",
    addPlaceholder: "Новая задача…",
    emptyInbox: "Входящие пусты. Записывайте сюда всё, что не относится к документу.",
    emptyToday: "На сегодня ничего. Хорошего дня!",
    emptyUpcoming: "Нет запланированных задач.",
    emptyAll: "Задач пока нет. Добавьте чек-бокс в любом документе — он появится здесь.",
    overdue: "Просрочено",
    noDate: "Без даты",
    schedule: "Перенести",
    deadline: "Дедлайн",
    complete: "Выполнить",
    reopen: "Вернуть в работу",
    cancel: "Отменить задачу",
    openDoc: "Открыть документ",
    move: "Переместить в…",
    deleteTask: "Удалить задачу",
    due: "до {{date}}",
    fromDoc: "из «{{title}}»",
    showDone: "Показывать выполненные",
    later: "Позже",
  },
  calendar: {
    title: "Календарь",
    todayBtn: "Сегодня",
    dailyNote: "Ежедневная заметка",
    createDaily: "Создать заметку дня",
    tasksForDay: "Задачи на день",
    noTasks: "Нет задач на этот день",
    week: "Неделя",
    month: "Месяц",
  },
  shared: {
    title: "Общие со мной",
    from: "Владелец: {{email}}",
    waiting: "Ждёт ключ от владельца",
    waitingHint: "Откроется, когда владелец будет в сети",
    readOnly: "Только чтение",
    readOnlyHint: "Владелец дал вам доступ только для чтения",
    agents: "Открыт ИИ-агентам",
    agentsHint: "Владелец открыл этот блокнот ИИ-агентам",
    leave: "Выйти",
    leaveTitle: "Выйти из «{{name}}»?",
    leaveText: "Документы исчезнут с этого устройства. Вернуться можно только по новому приглашению владельца.",
    left: "Вы вышли из общего доступа",
    gone: "Доступ закрыт владельцем",
  },
  openInApp: {
    invited: "Вас пригласили в общий блокнот или документ.",
    orSignInHere: "или войдите здесь",
    button: "Открыть в приложении",
    missing: "Приложение не открылось — похоже, оно не установлено. Продолжайте здесь, в браузере.",
  },
  invitations: {
    row: "Приглашения",
    title: "Приглашения",
    toNotebook: "приглашает вас в блокнот",
    toSpace: "приглашает вас в общее пространство",
    toNote: "приглашает вас в документ",
    until: "до {{date}}",
    accept: "Принять",
    decline: "Отклонить",
    accepted: "Готово — смотрите в «Общие со мной»",
    acceptedWaiting: "Принято. Появится в «Общие со мной», как только владелец будет в сети",
    none: "Новых приглашений нет",
    gone: "Это приглашение уже принято, отклонено, отозвано или истекло",
    hint: "Название станет видно после принятия: сервер его не знает, оно зашифровано.",
  },
  share: {
    people: {
      title: "Пригласить по почте",
      email: "Почта",
      emailPlaceholder: "name@example.com",
      editor: "Может редактировать",
      viewer: "Только чтение",
      invite: "Пригласить",
      invited: "Приглашение отправлено",
      hint: "Человек увидит приглашение в программе. Если аккаунта у него ещё нет — после регистрации; ссылку на приглашение можно отправить самому.",
      ownEmail: "Это ваша почта.",
      you: "Вы",
      owner: "Владелец",
      awaitingKey: "Принял приглашение — откроем доступ, как только вы будете в сети",
      registeredAfter: "Зарегистрировался после приглашения — ждёт вашего подтверждения",
      invitedUntil: "Приглашён · {{role}} · до {{date}}",
      copyInvite: "Скопировать ссылку на приглашение",
      cancelInvite: "Отозвать приглашение",
      remove: "Закрыть доступ",
      removeTitle: "Закрыть доступ для {{email}}?",
      removeText: "Ключ сменится, и новых изменений этот человек не увидит. То, что он уже видел, у него останется — так устроено сквозное шифрование.",
      removed: "Доступ закрыт",
      limit: "В одном блокноте не больше 50 человек, считая приглашённых.",
      tooMany: "Слишком много приглашений за сегодня. Попробуйте завтра.",
      confirmLateTitle: "{{email}} зарегистрировался после приглашения — открыть доступ?",
      confirmLateText: "Почта при регистрации не подтверждается письмом. Откройте доступ, только если уверены, что это тот самый человек.",
      confirmLateYes: "Открыть доступ",
      confirmLateNo: "Не сейчас",
      confirmNotInvitedTitle: "{{email}} ждёт доступа, но этот аккаунт его не приглашал — открыть доступ?",
      confirmNotInvitedText: "Ваши устройства не помнят такого приглашения. Если вы не приглашали этого человека, откажите: возможно, ключ блокнота пытается получить сервер.",
      confirmKeyChangedTitle: "У {{email}} сменился ключ — открыть доступ?",
      confirmKeyChangedText: "Ключ аккаунта этого человека не тот, которому ваши устройства открывали доступ раньше. Соглашайтесь, только если он сам сказал, что заново настроил аккаунт.",
      giveAccess: "Открыть доступ",
    },
    title: "Поделиться",
    note: "Документ",
    notebook: "Блокнот",
    guestLink: "Ссылка для гостей без аккаунта",
    permission: "Доступ",
    view: "Только просмотр",
    edit: "Может править и рисовать",
    expires: "Срок действия",
    expiresNever: "До отзыва",
    expires1d: "1 день",
    expires7d: "7 дней",
    expires30d: "30 дней",
    createLink: "Создать ссылку",
    copyLink: "Скопировать ссылку",
    revoke: "Отозвать",
    revoked: "Ссылка отозвана",
    active: "Активные ссылки",
    keyHint: "Ключ шифрования — в части ссылки после #. Он не уходит на сервер: без полной ссылки документ не прочитать.",
    agentModeNote: "Сервер видит этот блокнот (режим «для агентов»).",
    expiresAt: "до {{date}}",
    noLinks: "Ссылок пока нет",
    linksRecreated_one: "Ключ доступа сменился — ссылка для гостей создана заново. Отправьте новую",
    linksRecreated_few: "Ключ доступа сменился — {{count}} ссылки для гостей созданы заново. Отправьте новые",
    linksRecreated_many: "Ключ доступа сменился — {{count}} ссылок для гостей созданы заново. Отправьте новые",
    linksRecreated_other: "Ключ доступа сменился — {{count}} ссылки для гостей созданы заново. Отправьте новые",
    linksShow: "Показать",
  },
  guest: {
    loading: "Открываем документ…",
    badLink: "Ссылка недействительна",
    badLinkText: "Её отозвали, срок действия истёк или ссылка скопирована не полностью.",
    viewOnly: "Только просмотр",
    canEdit: "Вы можете править и рисовать",
    guest: "Гость",
    getApp: "Свой Datascratch",
    documents: "Документы блокнота",
  },
  history: {
    title: "История версий",
    empty: "Сохранённых версий пока нет. Версии появляются по мере работы с документом.",
    current: "Текущая",
    restore: "Восстановить эту версию",
    restored: "Версия восстановлена",
    loadFailed: "Не удалось загрузить версию",
    preview: "Просмотр",
    version: "Версия",
    changes: "Изменения",
    noTextChanges: "В тексте ничего не менялось — изменились рисунки, оформление или вложения.",
    you: "Вы",
    someone: "Участник",
    guest: "Гость по ссылке",
    agent: "Агент",
    agentNamed: "Агент «{{name}}»",
  },
  style: {
    font: "Шрифт",
    serif: "С засечками",
    sans: "Без засечек",
    mono: "Моноширинный",
    width: "Ширина",
    normal: "Обычная",
    wide: "Широкая",
    full: "Во всю ширину",
    paper: "Бумага",
    plain: "Гладкая",
    dots: "Точки",
    grid: "Клетка",
    lines: "Линейка",
    cover: "Обложка",
    addCover: "Добавить обложку",
    removeCover: "Убрать обложку",
    icon: "Значок",
    addIcon: "Добавить значок",
  },
  pen: {
    showPalette: "Палитра пера ({{tool}}) — развернуть",
    hidePalette: "Свернуть палитру пера",
    tool: { text: "текст", pen: "ручка", pencil: "карандаш", marker: "маркер", highlighter: "текстовыделитель", eraser: "ластик", lasso: "лассо" },
  },
  cover: {
    description: "Своё изображение: фото, скриншот или картинка из файла.",
    hint: "Перетащите изображение сюда или вставьте его (⌘V)",
    choose: "Выбрать файл",
    notImage: "Это не изображение",
  },
  settings: {
    recoveryTitle: "Ключ восстановления",
    recoveryUnconfirmed: "Вы ещё не подтвердили, что сохранили ключ. Без него забытый пароль не восстановить.",
    recoveryConfirmed: "Ключ сохранён. Посмотреть его можно в любой момент.",
    recoveryElsewhere: "Ключ показан на устройстве, где вы регистрировались.",
    recoveryElsewhereUnconfirmed: "Ключ показан на устройстве, где вы регистрировались. Если он не сохранён — создайте новый.",
    recoveryNew: "Создать новый ключ",
    recoveryNewTitle: "Новый ключ восстановления",
    recoveryNewText: "Старый ключ сразу перестанет работать. Новый покажем один раз — сохраните его.",
    recoveryNewCreate: "Создать",
    securityLog: "Журнал безопасности",
    securityEvent: {
      password_changed: "Смена пароля",
      recovery_used: "Вход по ключу восстановления",
      recovery_key_rotated: "Новый ключ восстановления",
    },
    recoveryShow: "Показать ключ",
    recoveryDone: "Ключ подтверждён",
    title: "Настройки",
    account: "Аккаунт",
    notebooks: "Блокноты",
    agents: "Агенты",
    appearance: "Внешний вид",
    devices: "Устройства",
    security: "Безопасность",
    email: "Почта",
    signOut: "Выйти",
    signOutText: "Локальные данные будут удалены с этого устройства.",
    signOutUnsent_one: "На этом устройстве {{count}} неотправленное изменение. Оно отправится после входа в этот же аккаунт.",
    signOutUnsent_few: "На этом устройстве {{count}} неотправленных изменения. Они отправятся после входа в этот же аккаунт.",
    signOutUnsent_many: "На этом устройстве {{count}} неотправленных изменений. Они отправятся после входа в этот же аккаунт.",
    signOutUnsent_other: "На этом устройстве {{count}} неотправленного изменения. Они отправятся после входа в этот же аккаунт.",
    sendFirst: "Сначала отправить",
    changePassword: "Сменить пароль",
    currentPassword: "Текущий пароль",
    passwordChanged: "Пароль изменён",
    wrongPassword: "Неверный пароль",
    deleteAccount: "Удалить аккаунт",
    deleteAccountText: "Все заметки будут удалены с сервера и всех устройств. Это нельзя отменить.",
    thisDevice: "Это устройство",
    lastSeen: "Был активен {{when}}",
    revokeDevice: "Завершить сеанс",
    revokeDeviceTitle: "Завершить сеанс на «{{name}}»?",
    revokeDeviceText: "Все данные на этом устройстве будут удалены, включая неотправленные изменения.",
    passwordOthersWiped: "Другие устройства будут отключены, данные на них удалены. Войти на них можно будет с новым паролем.",
    theme: "Тема",
    themeSystem: "Как в системе",
    themeLight: "Светлая",
    themeDark: "Тёмная",
    language: "Язык",
    mcpTitle: "Подключение ИИ-агента",
    mcpText: "Добавьте этот адрес как MCP-сервер в Claude, ChatGPT или другом агенте. Агент откроет страницу входа, где вы выберете блокноты (только в режиме «для агентов»).",
    oauthConnection: "Подключение",
    lastUsed: "Использован {{when}}",
    agentTokens: "Токены агентов",
    agentTokensText: "Токен даёт ИИ-агенту (Claude, ChatGPT и др.) доступ к выбранным блокнотам в режиме «для агентов» через MCP или REST.",
    newToken: "Новый токен",
    tokenName: "Название",
    tokenNotebooks: "Блокноты",
    tokenPermission: "Права",
    tokenRead: "Только чтение",
    tokenReadWrite: "Чтение и правка",
    allAgentNotebooks: "Все блокноты «для агентов»",
    tokenCreated: "Скопируйте токен сейчас — больше он не будет показан.",
    tokenRevoke: "Отозвать",
    noTokens: "Токенов нет",
    noAgentNotebooks: "Нет блокнотов в режиме «для агентов». Включите режим у блокнота во вкладке «Блокноты».",
    audit: "Журнал",
    noAudit: "Действий пока не было",
    storage: "Данные на устройстве",
    storageText: "Все заметки хранятся на этом устройстве и доступны без сети.",
    dailyNotebook: "Блокнот для ежедневных заметок",
    version: "Версия {{version}}",
  },
  dates: { at: "{{date}} в {{time}}" },
  connect: {
    title: "Подключаем ИИ-агента…",
    text: "Сейчас откроется экран, где вы выберете, к каким блокнотам дать доступ.",
    badLink: "Ссылка подключения недействительна",
    badLinkText: "Откройте подключение заново из приложения агента (Claude, ChatGPT…).",
    failed: "Не удалось подключить агента",
  },
  pwa: { update: "Доступна новая версия", reload: "Обновить", offlineReady: "Приложение готово к работе офлайн" },
};

export default ru;
export type Messages = typeof ru;
